import React from 'react'
import PropTypes from 'prop-types'
import { observer, inject } from 'mobx-react'
import hexToRgba from 'hex-to-rgba'

import ShortTextModel, { NULL as ShortTextModelNULL } from './model'
import EditorModel, {
  NULL as EditorModelNULL,
} from '@client/components/Editor/model'
import AppModel, { NULL as AppModelNULL } from '@client/components/App/model'
import { BLOCK_TYPES, FIELD_TYPES } from '@client/components/Block/constants'
import { getValueOrDefaultText } from '@client/utils/getValueOrDefault'
import { DEFAULT_INPUT_TYPE, defaultText } from './constants'
import PhoneInput from '@client/components/PhoneInput/PhoneInput'

import inlineStyles from './inlineStyles'

export const ShortText = ({
  model = ShortTextModelNULL,
  editor = EditorModelNULL,
  app = AppModelNULL,
  serverRender = false,
}) => {
  const globalSettings = editor.settings.values
  const settings = model.settings.values
  const isRequired = settings.isRequired || false
  const question = getValueOrDefaultText(
    settings.question,
    defaultText.question
  )
  const inputType = settings.inputType || DEFAULT_INPUT_TYPE
  const hasHelpText = settings.hasHelpText || false
  const helpText = getValueOrDefaultText(
    settings.helpText,
    defaultText.helpText,
    true
  )

  if (inputType === 'tel') {
    const field = {
      required: isRequired,
      disabled: false,
      name: model.inputName,
      defaultLabel: 'blocks.form.fields.sms.label',
      label: question,
      default: true,
    }
    return (
      <PhoneInput
        name={model.inputName}
        formatMessage={app.formatMessage}
        field={field}
        labelColor={globalSettings.normalText_color}
        globalSettings={globalSettings}
        labelFontSize={inlineStyles.label.fontSize.replace('px', '')}
        settings={settings}
        serverRender={serverRender}
        inputStyleProp={{
          borderRadius: undefined,
          borderColor: undefined,
          borderWidth: undefined,
          width: '100%',
          paddingTop: '5px',
          paddingBottom: '5px',
          paddingRight: '10px',
          fontSize: `16px`,
          fontFamily: globalSettings.normalText_fontFamily,
          '--tw-ring-color': hexToRgba(globalSettings.themeColor, 1).replace('1)', 'var(--tw-ring-opacity))'),
          backgroundColor: 'transparent',
        }}
        labelStyleProp={{
          ...inlineStyles.label,
          color: globalSettings.normalText_color,
          fontFamily: globalSettings.normalText_fontFamily,
          maxWidth: 'none',
          whiteSpace: 'normal',
          overflow: 'visible',
          textOverflow: 'clip',
        }}
        inputClassName="rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
      />
    )
  }

  return (
    <div
      data-type={BLOCK_TYPES.FIELD}
      data-field-type={FIELD_TYPES.SHORT_TEXT}
      className={`gan-field ${isRequired ? 'gan-field-required' : ''}`}
    >
      <label
        style={{
          ...inlineStyles.label,
          color: globalSettings.normalText_color,
          fontFamily: globalSettings.normalText_fontFamily,
        }}
      >
        {question}
      </label>
      {hasHelpText && (
        <span
          className="help-text"
          style={{
            fontFamily: globalSettings.normalText_fontFamily,
          }}
        >
          {helpText}
        </span>
      )}
      <input
        type={inputType}
        placeholder={app.formatMessage('fields.shorttext.answer.placeholder')}
        name={model.inputName}
        required={isRequired}
        className="rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
        style={{
          width: '100%',
          padding: '5px 10px',
          fontSize: `16px`,
          fontFamily: globalSettings.normalText_fontFamily,
          '--tw-ring-color': hexToRgba(globalSettings.themeColor, 1).replace('1)', 'var(--tw-ring-opacity))'),
          backgroundColor: 'transparent',
        }}
      />
      <div
        className="gan-validation-field-error"
        style={{
          color: 'red',
          fontSize: `${
            globalSettings.normalText_fontSize * 0.7
          }px`,
        }}
      />
    </div>
  )
}

ShortText.propTypes = {
  model: PropTypes.instanceOf(ShortTextModel),
  editor: PropTypes.instanceOf(EditorModel),
  app: PropTypes.instanceOf(AppModel),
  serverRender: PropTypes.bool,
}

export default inject('editor', 'serverRender', 'app')(observer(ShortText))
